module.exports = __webpack_public_path__ + "static/media/2_tatapower.7a19c149.svg";